(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/store/tickets-einstant-context.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/store/tickets-einstant-context.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  createContext,
  useReducer,
  useEffect
} = React;
const routerContext = createContext();
const actions = {
  GAME_URL: 'GAME_URL',
  UPDATE_CATEGORIES: 'UPDATE_CATEGORIES'
};
const reducer = function (state) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    GAME_URL,
    UPDATE_CATEGORIES
  } = actions;
  const {
    type,
    payload
  } = action;
  switch (type) {
    case GAME_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        gameUrl: payload.gameUrl
      });
    case UPDATE_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        categories: payload.categories
      });
    default:
      return state;
  }
};
const createInitialState = match => {
  var _match$params;
  return {
    gameUrl: match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.gameId,
    baseUrl: window.location.pathname,
    categories: svs.eInstant.data.categories || []
  };
};
const RouterProvider = _ref => {
  let {
    children
  } = _ref;
  const infoMatch = svs.eInstant.util.infoPageMatch;
  const match = infoMatch();
  const [state, dispatch] = useReducer(reducer, createInitialState(match));
  useEffect(() => {
    window.addEventListener('popstate', () => {
      var _match$params2;
      const match = infoMatch();
      dispatch({
        type: actions.GAME_URL,
        payload: {
          gameUrl: match === null || match === void 0 || (_match$params2 = match.params) === null || _match$params2 === void 0 ? void 0 : _match$params2.gameId
        }
      });
    });
  }, []);
  return React.createElement(routerContext.Provider, {
    value: {
      dispatch,
      state
    }
  }, children);
};
setGlobal('svs.eInstant.store', {
  reducer,
  actions,
  RouterContext: routerContext,
  RouterProvider,
  createInitialState
});

 })(window);